<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper">
      <div class="h1 h1-mob-lg crypto-payment-header">
        {{ $t('crypto_payment.transfer_using_the_following_details', { currency: $store.getters.selectedCryptoCurrencySymbol }) }}
      </div>
      <div class="crypto-payment-cols">
        <div class="crypto-payment-col-1">
          <div class="box-field">
            <div class="crypto-payment-form-group">
                <div class="crypto-payment-form-label">{{ $t('crypto_payment.amount') }}:</div>
                <input
                v-on:focus="$event.target.select()"
                ref="inputAmount"
                type="text"
                class="form-control form-control_name pointer"
                readonly
                @click="copyAmount"
                :value="$store.getters.amount"
                >
                <p
                class="popup-message"
                ref="inputAmountCopiedText"
                >{{ $t('crypto_payment.amount_copied') }}</p>
            </div>
            <div class="crypto-payment-form-group">
                <div class="crypto-payment-form-label">{{ $t('crypto_payment.to_the_address') }}:</div>
                <input
                v-on:focus="$event.target.select()"
                ref="inputAddress"
                type="text"
                class="form-control form-control_name pointer"
                readonly
                @click="copyAddress"
                :value="$store.getters.paymentAddress"
                >
                <p
                ref="inputAddressCopiedText"
                class="popup-message"
                >{{ $t('crypto_payment.address_copied') }}</p>
            </div>
          </div>
          <div class="crypto-qr-block">
            <div class="payment-QR-code-block">
              <img :src="$store.getters.paymentQRCode" />
            </div>
          </div>
        </div>
        <div class="crypto-payment-col-2">
          <div class="crypto-qr-block" v-if="$store.getters.paymentURL">
            <div class="h2 h2-mob-lg crypto-checkout-top-note">
              {{ $t('crypto_payment.if_you_have_the_wallet_app_installed', { currency: $store.getters.selectedCryptoCurrencySymbol }) }}:
            </div>
            <div class="payment-url">
              <a :href="$store.getters.paymentURL" class="btn-orange">{{ $t('crypto_payment.pay_in_the_app') }}</a>
            </div>
          </div>
          <div class="h2 h2-mob-lg crypto-checkout-bottom-note" v-if="!donationOnlyMode">
            <router-link v-if="$store.getters.effectGenerationSession" :to="{ path: '/generate', query: { session: $store.getters.effectGenerationSession.uuid }}" tag="span" v-html="$t('crypto_payment.we_will_redirect_you_to_the_sticker_creation_page', {'href': `/generate?session=${$store.getters.effectGenerationSession.uuid}`})"/>
            <span v-else>{{ $t('crypto_payment.your_effect_will_appear_on_the_stream_after_one_confirmation') }}</span>
          </div>
          <div class="payment-status-block">
            <div class="progress progress-striped active">
              <div role="progressbar" class="progress-bar progress-bar-primary">
                <span v-if="$store.getters.cryptocurrencyPaymentMode == 'awaiting_payment'">{{ $t('crypto_payment.awaiting_payment') }}</span>
                <span v-else-if="$store.getters.cryptocurrencyPaymentMode == 'awaiting_confirmation'">{{ $t('crypto_payment.awaiting_confirmation') }}</span>
              </div>
            </div>
          </div>
          <div class="btns">
              <a href="/" class="orange-link">{{ $t('crypto_payment.go_back') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CryptoPayment',
  methods: {
    copyAmount() {
      this.$refs.inputAmount.focus();
      this.$refs.inputAmountCopiedText.style.opacity = 1;
      document.execCommand('copy');
      setTimeout(() => {
        this.$refs.inputAmountCopiedText.style.opacity = 0;
      }, 2000)
    },
    copyAddress() {
      this.$refs.inputAddress.focus();
      this.$refs.inputAddressCopiedText.style.opacity = 1;
      document.execCommand('copy');
      setTimeout(() => {
        this.$refs.inputAddressCopiedText.style.opacity = 0;
      }, 2000)
    },
  },
  computed: {
    donationOnlyMode() {
      return this.$store.getters.donationOnlyMode;
    },
  }
};
</script>

<style lang="scss">
.crypto-payment-form-group {
    width: 350px;
    .form-control {
        font-size: 12px;
    }
}
.crypto-qr-block {
    width: 350px;
}
.crypto-checkout-top-note {
    margin: 20px 0 10px 0;
}
.crypto-checkout-bottom-note {
    margin-top: 40px;
}
.crypto-payment-cols {
    display: flex;
    flex-direction: row;
}
.crypto-payment-col-1 {
    flex: 1;
}
.crypto-payment-col-2 {
    flex: 1;
}
.progress-bar {
  background-color: #2196F3;
  box-shadow:none;
  width: 100%;
  height: auto;
  span{
    top: 25%;
    position: relative;
    color: #f5f5f5;
    font-weight: 500;
  }
}
</style>
